/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const CreateProjectDtoSourceTypeEnum = {
    FRAGMENT: "FRAGMENT"
} as const;

export type CreateProjectDtoSourceTypeEnumKey = (typeof CreateProjectDtoSourceTypeEnum)[keyof typeof CreateProjectDtoSourceTypeEnum];

export type CreateProjectDto = {
    /**
     * @type string
    */
    sourceType: CreateProjectDtoSourceTypeEnumKey;
    /**
     * @type string, uuid
    */
    sourceId: string;
    /**
     * @minLength 1
     * @type string
    */
    name: string;
    /**
     * @type object | undefined
    */
    config?: {
        /**
         * @type string | undefined, uri
        */
        videoUrl?: string;
        /**
         * @type string | undefined, uri
        */
        captionsUrl?: string;
    };
};